import { NumberData } from '@/types/common';
export const activationStatus: NumberData = {
  1: '待機中',
  2: '依頼中',
  7: 'キャンセル済',
  8: '完了',
  9: 'エラー'
};
